/**
 * Animate numbers.
 *
 * @return {Void}
 */
export const animateNumbers = () => {
	const container = document.querySelectorAll('.js-count-to');

	if (!container.length) {
		return;
	}

	for (let n of container) {

		/**
		 * Update count.
		 *
		 * @return {Void}
		 */
		const updateCount = () => {
			const target = + n.getAttribute('data-count');
			const count = + n.innerText;
			const speed = 5000;
			const timeout = n.getAttribute('data-speed');
			const inc = target / speed;

			if(count < target) {
				n.innerText = Math.ceil(count + inc);
				setTimeout(updateCount, timeout);
			} else {
				n.innerText = target;
			}
		}
		updateCount();
	}
};
